import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { ObraModel } from 'src/app/models/ventas/tablas-maestras.model';


export class ObraListModalFormDefinition {
  public readonly formFields: Form<ObraModel>;
  public readonly model: Partial<ObraModel>;

  constructor(type: FormType, model: Partial<ObraModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'obra-list-modal',
      header: 'Detalle del registro',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<ObraModel>[] {
    return [
      {
        name: '',
        fields: [
          this.textField('nombre', 'Nombre', 1, true, 4),
          this.textField('cliente_nombre', 'Cliente', 2, true, 4),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<ObraModel> {
    return {
      name,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
